import { render, staticRenderFns } from "./PositionRimorchioBox.vue?vue&type=template&id=5f07155d&scoped=true"
import script from "./PositionRimorchioBox.vue?vue&type=script&lang=js"
export * from "./PositionRimorchioBox.vue?vue&type=script&lang=js"
import style0 from "./PositionRimorchioBox.vue?vue&type=style&index=0&id=5f07155d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f07155d",
  null
  
)

export default component.exports